import React, { useState, useCallback } from 'react';
import { CoursesList } from './components/CoursesList';
import { SpecializationsList } from './components/SpecializationsList';
import { AcademicGroupsList } from './components/AcademicGroupsList';
import { LeastAcademicGroupsList } from './components/LeastAcademicGroupsList';
import { StudentsList } from './components/StudentsList';
import { BreadcrumbNavigation } from './components/BreadcrumbNavigation';
import { FinanceSummaryCard } from './components/FinanceSummaryCard';
import './styles/AcademicFinanceDashboard.css';
import exporticon from '../../assets/icons/export-data.svg';
import { getBlob } from '../../API/GlobalApi';
import Notifier from '../../Utils/notify';
export const AcademicFinanceDashboard = () => {
  const [navigationStack, setNavigationStack] = useState([
    { level: 'courses', id: null, name: 'Courses' }
  ]);
  const [grandTotals, setGrandTotals] = useState({
    total_students: 0,
    total_imposed_fees: 0,
    total_scheduled_fee: 0,
    total_paid_fees: 0
  });

  const currentLevel = navigationStack[navigationStack.length - 1];

  const handleNavigate = useCallback((level, id, name) => {
    setNavigationStack(prev => [...prev, { level, id, name }]);
  }, []);

  const handleBreadcrumbClick = useCallback((index) => {
    setNavigationStack(prev => prev.slice(0, index + 1));
  }, []);

  const handleUpdateGrandTotals = useCallback((totals) => {
    setGrandTotals(totals);
  }, []);
  const [isExporting, setIsExporting] = useState(false);

  const handleExportExcel = async () => {
    try {
      setIsExporting(true); // start spinner

      const blob = await getBlob('academics/finance/courses/export-master-excel/');

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Master_finance_report_export.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      Notifier.error('❌ Excel export failed');
    } finally {
      setIsExporting(false); // stop spinner
    }
  };

  const renderCurrentView = () => {
    switch (currentLevel.level) {
      case 'courses':
        return (
          <CoursesList
            onCourseClick={handleNavigate}
            onUpdateGrandTotals={handleUpdateGrandTotals}
          />
        );
      case 'specializations':
        return (
          <SpecializationsList
            courseId={currentLevel.id}
            onSpecializationClick={handleNavigate}
            onUpdateGrandTotals={handleUpdateGrandTotals}
          />
        );
      case 'academic-groups':
        return (
          <AcademicGroupsList
            specializationId={currentLevel.id}
            onAcademicGroupClick={handleNavigate}
            onUpdateGrandTotals={handleUpdateGrandTotals}
          />
        );
      case 'least-academic-groups':
        return (
          <LeastAcademicGroupsList
            academicGroupId={currentLevel.id}
            onLeastAcademicGroupClick={handleNavigate}
            onUpdateGrandTotals={handleUpdateGrandTotals}
          />
        );
      case 'students':
        return (
          <StudentsList
            leastAcademicGroupId={currentLevel.id}
            onUpdateGrandTotals={handleUpdateGrandTotals}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="academic-finance-dashboard">
      <div className="dashboard-header">
        <div className='d-flex justify-content-between gap-5'>
          <h1>Academic Finance Dashboard</h1>
          <button
            className="filter-btn"
            style={{ background: 'white', border: '1px solid #7F56DA', height: '43px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
            onClick={handleExportExcel}
            title="Export Courses Finance Data"
            disabled={isExporting}
          >
            {isExporting ? (
              <span className="spinner-border spinner-border-sm" role="status" style={{ color: '#7F56DA' }} />
            ) : (
              <img src={exporticon} alt="Filter icon" />
            )}

            {/* Optional text */}
            {/* {!isExporting && <span>Export</span>} */}
          </button>

        </div>

        <BreadcrumbNavigation
          navigationStack={navigationStack}
          onBreadcrumbClick={handleBreadcrumbClick}
        />
      </div>

      <FinanceSummaryCard grandTotals={grandTotals} />

      <div className="dashboard-content">
        {renderCurrentView()}
      </div>
    </div>
  );
};
